// Global Google Identity Services initialization
let isInitialized = false;

export const initializeGoogleIdentityServices = () => {
  if (isInitialized) return;
  
  // Check if script is already loaded
  const existingScript = document.querySelector('script[src="https://accounts.google.com/gsi/client"]');
  if (existingScript) {
    // Script exists, check if Google is ready
    // @ts-ignore
    if (window?.google?.accounts?.id) {
      try {
        // @ts-ignore
        window.google.accounts.id.initialize({
          client_id: import.meta.env.VITE_GOOGLE_CLIENT_ID,
          // We'll set specific callbacks when rendering buttons
        });
        isInitialized = true;
        console.log('Google Identity Services initialized globally');
      } catch (error) {
        console.error('Error initializing Google Identity Services:', error);
      }
    }
    return;
  }
  
  // Load the script if not already loaded
  const script = document.createElement('script');
  script.src = 'https://accounts.google.com/gsi/client';
  script.async = true;
  script.defer = true;
  
  script.onload = () => {
    // Initialize as soon as script loads
    const checkGoogle = setInterval(() => {
      // @ts-ignore
      if (window?.google?.accounts?.id) {
        clearInterval(checkGoogle);
        try {
          // @ts-ignore
          window.google.accounts.id.initialize({
            client_id: import.meta.env.VITE_GOOGLE_CLIENT_ID,
          });
          isInitialized = true;
          console.log('Google Identity Services initialized after script load');
        } catch (error) {
          console.error('Error initializing Google Identity Services:', error);
        }
      }
    }, 100);
    
    // Stop checking after 10 seconds
    setTimeout(() => clearInterval(checkGoogle), 10000);
  };
  
  document.head.appendChild(script);
};

// Call this immediately when the module loads
initializeGoogleIdentityServices();